import {PAYMENT_METHODS} from 'constants/checkout/paymentMethods';

export const ANALITYCS_PAYMENT_METHODS = {
    ...PAYMENT_METHODS,
    [PAYMENT_METHODS.APPLEPAY]: 'apple_pay',
    [PAYMENT_METHODS.GIFT]: 'giftcert',
};
